import { render } from "./ViewPolicy.vue?vue&type=template&id=47a4ba71&scoped=true&ts=true"
import script from "./ViewPolicy.vue?vue&type=script&lang=ts"
export * from "./ViewPolicy.vue?vue&type=script&lang=ts"

import "./ViewPolicy.vue?vue&type=style&index=0&id=47a4ba71&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a4ba71"],['__file',"src/views/ViewPolicy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47a4ba71"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47a4ba71', __exports__)) {
    api.reload('47a4ba71', __exports__)
  }
  
  module.hot.accept("./ViewPolicy.vue?vue&type=template&id=47a4ba71&scoped=true&ts=true", () => {
    api.rerender('47a4ba71', render)
  })

}


export default __exports__